export default "__VITE_ASSET__YsNmMQxu__"